"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ouroboro;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styleModule = _interopRequireDefault(require("./style.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Ouroboro({
  color,
  className,
  style
}) {
  return (
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: (0, _classnames.default)(_styleModule.default['lds-ouroboro'], className),
      style: _objectSpread({}, style)
    },
    /*#__PURE__*/
    _react.default.createElement("span", {
      className: (0, _classnames.default)(_styleModule.default.left)
    },
    /*#__PURE__*/
    _react.default.createElement("span", {
      className: (0, _classnames.default)(_styleModule.default.anim),
      style: {
        background: color
      }
    })),
    /*#__PURE__*/
    _react.default.createElement("span", {
      className: (0, _classnames.default)(_styleModule.default.right)
    },
    /*#__PURE__*/
    _react.default.createElement("span", {
      className: (0, _classnames.default)(_styleModule.default.anim),
      style: {
        background: color
      }
    })))
  );
}

Ouroboro.propTypes = {
  /** hex color */
  color: _propTypes.default.string,

  /** class name  */
  className: _propTypes.default.string,

  /** style object */
  style: _propTypes.default.object
};
Ouroboro.defaultProps = {
  color: '#7f58af',
  className: '',
  style: {}
};